import classNames from 'classnames';
import { HTMLProps } from 'react';
import { cn } from 'v5/platform/dom/cn';

export function getDimmedContainerClassName(shouldDim: boolean) {
  return classNames('transition duration-500 ease-out', {
    'blur-[1px] opacity-80 ease-in animate-pulse': shouldDim
  });
}

export function DimmedContainer({
  className,
  shouldDim,
  ...rest
}: { shouldDim: boolean } & HTMLProps<HTMLDivElement>) {
  return (
    <div
      className={cn(getDimmedContainerClassName(shouldDim), className)}
      {...rest}
    />
  );
}
